export const PAGES_COUNT_OPTIONS = [10, 20, 50, 100];
export const NOT_SORTABLE_COLUMNS = ["edit"];
